import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\ExecuteMergeController::__invoke
* @see app/Http/Controllers/ContactDirectory/ExecuteMergeController.php
* @route '/api/contact-directory/merge'
*/
const ExecuteMergeController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExecuteMergeController.url(options),
    method: 'post',
})

ExecuteMergeController.definition = {
    methods: ["post"],
    url: '/api/contact-directory/merge',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ContactDirectory\ExecuteMergeController::__invoke
* @see app/Http/Controllers/ContactDirectory/ExecuteMergeController.php
* @route '/api/contact-directory/merge'
*/
ExecuteMergeController.url = (options?: RouteQueryOptions) => {
    return ExecuteMergeController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\ExecuteMergeController::__invoke
* @see app/Http/Controllers/ContactDirectory/ExecuteMergeController.php
* @route '/api/contact-directory/merge'
*/
ExecuteMergeController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExecuteMergeController.url(options),
    method: 'post',
})

export default ExecuteMergeController